export default "__VITE_ASSET__1a575142__"